import React from 'react';
import { map, fromPairs, find } from 'lodash';

// local dependencies
import { getLabel } from 'utils/getLabel';
import { Icon } from 'modules/icon-bank';
import { button as Button } from 'modules/button';
import { SIZES } from 'constants/common';
import { Form } from 'modules/form';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { editWellConnectPhone as EditWellConnectPhone } from 'ui/views/widgets/editWellConnectPhone';
 *
 * // render
 * <EditWellConnectPhone propName='propValue'/>
 */
export const editWellConnectPhone = ( props ) => {
    return (
        <div className='ui-edit-well-connect-phone'>

            {/* header */}
			<div className='ui-edit-well-connect-phone__header'>

				{ /* title for the modal */ }
				<div className='ui-edit-well-connect-phone__header__title'>
					{ getLabel( props.title ) }
				</div>

				{ /* close button */ }
				<div
					className='ui-edit-well-connect-phone__header__close'
					onClick={ props.onCancelClick }
				>
					<Icon name='close' width='14' height='14' fill='#ffffff' />
				</div>
			</div>

            {/*  body */}
			<div className='ui-edit-well-connect-phone__body'>
                <Form
                    fields={ fromPairs( map( props.fields, ( field ) => [ field.name, field ] ) ) } // convert to object as specified by `Form` prop
                    values={ props.values }
                    isValid={ false }
                    mode='form'
                    onSubmit={ ( { values, isValid } ) => {
                        if( isValid ) {
                            props.onFormSubmit( {
                                formData: values,
                                saveAction: find( props.actions, { name: 'save' } )
                            } );
                        }
                    } }
                >
                    { ( { fields, values, errors, onChange, onSumbit } = {} ) => {
                        return (
                            <form
                                onSubmit={ onSumbit }
                                className='ui-edit-well-connect-phone__body__form'
                            >
                                { /* fields */ }
                                { map( fields, ( field ) => {

                                    return (
                                        <field.view
                                            className='ui-edit-well-connect-phone__body__form__field'
                                            key={ field.name }
                                            name={ field.name }
                                            required={ field.required }
                                            label={ field.title }
                                            placeholder={ field.placeholder }
                                            onChange={ onChange }
                                            value={ values[ field.name ] }
                                            error={ errors[ field.name ] }
                                            mask={ field.mask }
                                        />
                                    );
                                } ) }

                                {/* actions */}
                                <div className='ui-edit-well-connect-phone__body__form__actions'>
                                    { map( props.actions, ( action ) => {
                                        const actionName = action.name;

                                        return (
                                            <Button
                                                className='ui-edit-well-connect-phone__body__form__actions__action'
                                                key={ actionName }
                                                id= { actionName }
                                                type= { 'cancel' !== actionName ? 'submit' : 'button' }
                                                title={ action.title }
                                                size={ SIZES.LARGE }
                                                outline={ 'cancel' === actionName ? true: false }
                                                onClick = { 'cancel' === actionName ?  props.onCancelClick : null }
                                            />
                                        );
                                    } ) }
                                </div>
                            </form>
                        );
                    } }
                </Form>
            </div>
		</div>
    );
};

// set display name
editWellConnectPhone.displayName = 'editWellConnectPhone';

// set default props
editWellConnectPhone.defaultProps = {};

// prop types
editWellConnectPhone.propTypes = {};
